import React, { useState } from 'react';
import './LoginPage.css';

const Login = ({ authenticate }) => {
    const handleSubmit = (event) => {
        event.preventDefault();
        const { username, password } = event.target.elements;
        authenticate(username.value, password.value);
    };

    return (
        <div className="login-background" >
            <form onSubmit={handleSubmit}>
                <input type="text" name="username" required />
                <input type="password" name="password" required />
                <button type="submit">Login</button>
            </form>
        </div>
    );
};


export default Login;
